export default __webpack_public_path__ + "static/media/youtube.3d1a0a49.png";